// export const REACT_APP_CARBON_BALANCE_URL = process.env.CARBON_BALANCE;
export const REACT_APP_CARBON_BALANCE_URL =
  process.env.REACT_APP_CARBON_BALANCE_URL;

  export const CTF_CARBON_BALANCE_URL = `${REACT_APP_CARBON_BALANCE_URL}/cft`